import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=6d84a5ef&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=ts"
export * from "./Terms.vue?vue&type=script&lang=ts"
import style0 from "./Terms.vue?vue&type=style&index=0&id=6d84a5ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84a5ef",
  null
  
)

export default component.exports